export default class Goods {
    constructor() {
        this._init();
    }

    _init() {
        this.itemUrl = "";
        this.clicked = false;
        this._fetchContent();
    }

    _fetchContent() {
        const trigger = [...document.querySelectorAll(".js-fetch_open")];
        const close = [...document.querySelectorAll(".js-fetch_close")];

        trigger.forEach((el) => {
            el.addEventListener("click", () => {
                //連打防止
                if (this.clicked === true) return;
                this.clicked = true;

                const itemId = el.getAttribute("data-itemid");

                this._setContent(itemId);
            });
        });

        close.forEach((el) => {
            el.addEventListener("click", () => {
                this._removeContent();
            });
        });
    }

    _setContent(itemId) {
        this.itemUrl = `./templates/detail.html?item_id=${itemId}`;
        const url = this.itemUrl;
        const inner = document.querySelector(".js-fetch_content");

        fetch(url)
            .then((res) => res.text())
            .then((data) => {
                console.log(data);

                const parser = new DOMParser();
                const doc = parser.parseFromString(data, "text/html");
                const content = doc.querySelector(".detail__main.-modal");
                console.log(itemId);

                console.log(url);
                console.log(parser);
                console.log(doc);
                console.log(content);
                inner.appendChild(content);
                this._setPrevNext();
                this._setSwiper();
            });
    }

    _setPrevNext() {
        [...document.querySelectorAll(".js-prevnext")].forEach(($btn) => {
            $btn.addEventListener("click", () => {
                this.clicked = false;
                const itemId = $btn.getAttribute("data-itemid");
                // const typeId = el.getAttribute("data-typeid");
                this._removeContent();
                this._setContent(itemId, typeId);
            });
        });
    }

    async _setSwiper() {
        const thumb = document.querySelectorAll(".detail__thumb__item");
        if (thumb.length <= 0) return;

        const { default: Swiper } = await import("swiper/bundle");
        await import("swiper/css/bundle");

        const firstactiveitem = document.querySelector('[data-swiper="0"]');
        firstactiveitem.classList.add("-active");

        const swiper = new Swiper(".detail__swiper", {
            speed: 700,
            on: {
                beforeTransitionStart: (e) => {
                    const thumbs = document.querySelector(".detail__thumb__item.-active");
                    thumbs.classList.remove("-active");

                    const activenum = e.activeIndex;
                    const activeitem = document.querySelector('[data-swiper="' + activenum + '" ]');
                    activeitem.classList.add("-active");
                },
            },
        });

        thumb.forEach((el) => {
            el.addEventListener("click", () => {
                const thumbnum = el.dataset.swiper;
                swiper.slideTo(thumbnum);
            });
        });
    }

    _removeContent() {
        const content = [...document.querySelectorAll(".detail__main.-modal")];
        content.forEach((el) => el.remove());
        this.clicked = false;
    }
}
